export const KS001Template = (BarData) => {

   let htmlContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Diamond Cards Print</title>
        <style>
          @page { size: 50mm 25mm; margin: 0; }
          body { margin:0mm; padding: 0; font-family: Arial; width: 50mm;  height:25mm;border:0px solid;}
          .diamond-card {margin-bottom: 2mm; border:0px solid; width: 48mm; height:23mm; padding: 1mm; box-sizing: border-box; page-break-after: always; justify-content: flex-start; }
          .left-side { width:100%; padding: 0mm; display: flex; flex-direction: column; justify-content: flex-start;  align-items: flex-start;}
          .mid-side { width:100%;  display: flex; flex-direction: column; justify-content: flex-start;  align-items: flex-start;}
          .right-side { width: 100%; padding: 0mm; display: flex; flex-direction: column; justify-content: flex-start;  align-items: flex-start;}
          .diamond-title, .diamond-info { font-weight: bold; padding:0;line-height: 1; margin:0;   font-size: 8px; margin-bottom: 0mm;   }
          .barcode-container { width: 100%; height: 8mm;    }
          .barcode { width: 100%; height: 100%; }
          .text-center {width:60%;   font-size:12px; font-weight: bold; padding:0;   margin-bottom: 0mm;   }
          .flex{display:flex; justify-content:start;   flex-direction: row;  border:0px solid; align-items: center;margin-left:2px;}
          .flexbox{display: grid;  grid-template-columns: 1fr 1fr 1fr; grid-auto-rows: auto; width: 100%; margin-left:2px; align-items: start;}
          .flextop{width: 100%;display:flex; justify-content:flex-start; border:0px solid; margin-left:2px; align-items: center;}
          .pd{padding:0.1mm}
          .smfont{font-size:8px;}
          .wlt{width:60%; border:0px solid; font-weight: bold; padding:0;line-height: 1; margin:0;   font-size: 9px; margin-bottom: 0mm;   }
          .wrt{width:40%; border:0px solid;   font-weight: bold; padding:0;line-height: 1; margin:0;   font-size: 9px; margin-bottom: 0mm;  }
        </style>
      </head>
      <body>
    `;

  BarData.forEach((diamond) => {

    htmlContent += `
        <div class="diamond-card">
         <div class="flex">
          <div class="barcode-container">  <svg id="barcode-${diamond.l_code}-${diamond.pktno}" class="barcode"></svg></div>
          </div>
          <div class='flextop'>
            <div class="text-center">${diamond.l_code}-${diamond.pktno}</div>
            <div class="wlt">${diamond.s_name}</div>
          </div>
           <div class="pd"></div>
        <div class="flexbox">
          <div class="left-side">
            <div class="diamond-info">Wt : ${diamond.bweight}</div>
            <div class="diamond-info">Color : ${diamond.sh_name}</div>
            <div class="diamond-info">Clarity : ${diamond.q_name}</div>
             
           </div>
          <div class="mid-side">
            <div class="diamond-info">Cut : ${diamond.cut_code}</div>
            <div class="diamond-info">Pol : ${diamond?.polish_code || ''}</div>
            <div class="diamond-info">Sym : ${diamond?.sym_code || ''}</div>
             
          </div>
          <div class="right-side">
            <div class="diamond-info">Table : ${diamond?.tbl_ptg || ''}</div>
            <div class="diamond-info">Depth : ${diamond?.tbl_dpth || ''}</div>
           <div class="diamond-info">Fc  : ${diamond?.fancy_color ||''}</div>
           
          </div>
        </div>
         <div class="pd"></div>
        <div class='flex'>
            <div class='wlt'}>MsrMnt :  ${diamond?.msrmnt || ''}</div>
            <div class='wrt'}>${diamond?.labid || ''} 
             ${diamond?.reportno ? `: ${diamond?.reportno || ''}` : ""}</div>
        </div>

        </div>
      `;
  });

  

  return htmlContent;
};